<template>
  <AppDialog
    class="batch-edit-budget-dialog"
    :title="title"
    :subtitle="subtitle"
    :loading="loading"
    show
    append-to-body
    @close="onClose"
  >
    <BudgetsForm
      ref="budgetsForm"
      :budget-state="payload"
      :organization="organization"
      has-budget
      only-batch-fields
      @change-budget-field="updateBudget"
    />
    <template #footer>
      <div>
        <div class="justify-content-end">
          <AppButton
            type="default"
            @click="onClose"
          >
            Cancel
          </AppButton>
          <AppButton
            type="primary"
            @click="saveChanges()"
          >
            Save
          </AppButton>
        </div>
      </div>
    </template>
  </AppDialog>
</template>
<script>
import { pluralize } from '~/utils/string_utils';
import { ProjectsResource } from '~/resources';
import BudgetsForm from '../budgets/BudgetsForm.vue';

export default {
  components: { BudgetsForm },
  props: {
    projects: {
      type: Array, // [{ :id }]
      required: true,
    },
    organization: {
      type: Object, // { id, currency }
      required: true,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      payload: { type: '', rate: 0 },
      loading: false,
    };
  },
  computed: {
    title() {
      return `Edit budget (${this.projects.length} ${this.projectsLabel})`;
    },
    subtitle() {
      return `Editing the selected ${this.projectsLabel} will override the existing settings.`;
    },
    projectsLabel() {
      return pluralize(this.projects.length, 'project', 'projects');
    },
  },
  methods: {
    async saveChanges() {
      const valid = await this.$refs.budgetsForm.validate();
      const payload = {
        project_ids: this.projects.map((p) => p.id),
        changed_attrs: { budget: this.payload },
      };

      if (!valid) {
        return;
      }

      this.loading = true;
      ProjectsResource.batchUpdate({ id: this.organization.id }, payload)
        .then(() => window.location.reload())
        .catch((error) => {
          this.loading = false;
          this.$appMessage(error.responseJSON?.alert || error.statusText);
        });
    },
    updateBudget(key, value) {
      if (key === 'hours_display') {
        this.payload = { ...this.payload, ...{ hours: value / 60 / 60 } };
      }
      this.payload = { ...this.payload, ...{ [key]: value } };
    },
  },
};
</script>
